export default __webpack_public_path__ + "static/illuSmall-e09f5ff2959b194b27ace6712326672c.svg";